// extracted by mini-css-extract-plugin
module.exports = {"container":"gV","image":"gW","title":"gX","date":"gY"};